
import axios from "axios";



const newsletterUrl = "https://feingeist-beratung.de/wp-json/contact-form-7/v1/contact-forms/145/feedback"
const contactUrl = "https://feingeist-beratung.de/wp-json/contact-form-7/v1/contact-forms/87/feedback"
const ebookUrl = "https://feingeist-beratung.de/wp-json/contact-form-7/v1/contact-forms/191/feedback"


export async function newsletterSubmission(formdata) {

  var newsletter_choice = '';
  if (formdata.unternehmensnachfolge && formdata.immobilienmanagementunternehmen) {
    newsletter_choice = "Unternehmensnachfolge & Immobilienmanagement-Unternehmen"
  } else if (formdata.unternehmensnachfolge) {
    newsletter_choice = "Unternehmensnachfolge"

  }
  else if (formdata.immobilienmanagementunternehmen) {
    newsletter_choice = "Immobilienmanagement-Unternehmen"
  }


  try {
    // Create an object with the form data
    // Create a FormData object
    const formData = new FormData();
    formData.append('your-name', formdata.name);
    formData.append('your-email', formdata.email);
    formData.append('newsletter_choice', newsletter_choice);
    formData.append('_wpcf7_unit_tag', "8b95a27");

    // console.log(formData);

    // Make a POST request using Axios
    const response = await axios.post(newsletterUrl, formData);
    // console.log("formData", response);
    // console.log("data", response.data);

    // Log the response
    // console.log("Form submission response:", response.data);

    // You can return the response or handle it in other ways as needed
    return response.data;
  } catch (error) {
    // Handle errors
    console.error("Error submitting form:", error);
    throw error; // You can choose to handle the error differently based on your needs
  }
}


export async function contactSubmission(formdata) {


  try {
    // Create an object with the form data
    // Create a FormData object
    const formData = new FormData();
    formData.append('your-name', formdata.name);
    formData.append('your-email', formdata.email);
    formData.append('your-message', formdata.message);
    formData.append('_wpcf7_unit_tag', "bf16c8c");

    // Make a POST request using Axios
    const response = await axios.post(contactUrl, formData);

    // Log the response
    // console.log("Form submission response:", response.data);

    // You can return the response or handle it in other ways as needed
    // alert("Message Sent Successfully");
    // console.log("res", response.data);
    return response.data;
  } catch (error) {
    // Handle errors
    console.error("Error submitting form:", error);
    throw error; // You can choose to handle the error differently based on your needs
  }
}




export async function ebookSubmission(formdata, ebook) {


  try {
    // Create an object with the form data
    // Create a FormData object
    const formData = new FormData();
    formData.append('your-name', formdata.name);
    formData.append('your-email', formdata.email);
    formData.append('phoneNo', formdata.phone);
    formData.append('_wpcf7_unit_tag', "f5755ee");

    const bookType = ebook == 1 ? "Ebook" : "ESG-Whitepaper";

    formData.append('book', bookType);

    // Make a POST request using Axios
    const response = await axios.post(ebookUrl, formData);

    // Log the response
    // console.log("Form submission response:", response.data);

    // You can return the response or handle it in other ways as needed
    return response.data;
  } catch (error) {
    // Handle errors
    console.error("Error submitting form:", error);
    throw error; // You can choose to handle the error differently based on your needs
  }
}